import React from 'react'
import { object } from 'prop-types'
import minifyCssString from '@/lib/css-string-minifier'

const RootColorVariables = ({ colors }) => {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: minifyCssString(`
          :root{
            --color-theme--secondary: ${colors.theme};
            --color-theme--primary: ${colors.primary};
            --color-theme--secondary: ${colors.secondary};
            --color-theme--event: ${colors.event};
          }
        `)
      }}
    />
  )
}

RootColorVariables.propTypes = {
  colors: object.isRequired
}

export default RootColorVariables
